const style = {
  checkedColor: {
    background: 'rgba(243, 244, 246, 1)',
    color: {
      color: 'primary.main',
      opacity: 0.3,
    },
  },
  avatar: {
    border: '3px solid rgba(48, 37, 133, 0.12)',
  },
  main: {
    mt: 3,
  },
  container: {
    spacing: 2,
    justifyContent: 'center',
    alignItems: 'center',
    sx: {
      pt: 3,
      pb: 3,
    },
  },
  inputProps: { 'aria-label': 'controlled' },
} as const;

export default style;
